import { __assign, __extends, __rest } from "tslib";
import { Shape } from '../types';
import { DisplayObject } from './DisplayObject';

var Ellipse =
/** @class */
function (_super) {
  __extends(Ellipse, _super);

  function Ellipse(_a) {
    if (_a === void 0) {
      _a = {};
    }

    var style = _a.style,
        rest = __rest(_a, ["style"]);

    return _super.call(this, __assign({
      type: Shape.ELLIPSE,
      style: __assign({
        rx: 0,
        ry: 0,
        anchor: [0.5, 0.5],
        lineWidth: 0
      }, style)
    }, rest)) || this;
  }

  return Ellipse;
}(DisplayObject);

export { Ellipse };